export function closestParentByTag(tagName, element) {
  if (!tagName) {
    return null;
  }

  tagName = tagName.toUpperCase();
  while (element) {
    if (tagName === element.tagName.toUpperCase()) {
      return element;
    }
    element = element.parentElement;
  }
  return null;
}

export function closestParentByClass(className, element) {
  if (!className) {
    return null;
  }

  while (element) {
    if (element.classList.contains(className)) {
      return element;
    }
    element = element.parentElement;
  }
  return null;
}

export function stripHTML(string) {
  const doc = new DOMParser().parseFromString(string, "text/html");
  return doc.body.textContent || "";
}